import { PauseRounded, PlayArrowRounded } from '@mui/icons-material';
import './PreviewPlayButton.css';

const PreviewPlayButton = ({ onClick, label, duration, compact = false, playing = false, disabled = false }) => {
    const controlLabel = duration && !label?.includes(duration) ? `${label}: ${duration}` : label;
    return <button
        type='button'
        onClick={onClick}
        disabled={disabled}
        aria-label={controlLabel}
        className={`previewInfoDurationButton${compact ? ' previewInfoDurationButtonCompact' : ''}`}>
        <span className={compact ? 'previewInfoPlaySurface' : 'trackInfoPlayPill blurBackground'}>
            {playing
                ? <PauseRounded className={compact ? 'previewInfoDurationButtonIcon' : 'trackInfoPlayPillIcon'} />
                : <PlayArrowRounded className={compact ? 'previewInfoDurationButtonIcon' : 'trackInfoPlayPillIcon'} />}
            <span className={compact ? 'previewInfoPlayDuration' : 'trackInfoPlayPillLabel'}>{duration}</span>
        </span>
    </button>;
};

export default PreviewPlayButton;
